export const getSocnetworkLink = (type: string, id: string) => {
  let link = '';

  switch (type) {
    case 'vk':
      link = `https://vk.com/id${id}`;
      break;
    case 'ok':
      link = `https://ok.ru/profile/${id}`;
      break;
    default:
      link = '';
  }

  return link;
};
